if (!customElements.get('clei-gift-card-recipient-tabs')) {
  class CleiGiftCardRecipientTabs extends HTMLElement {
    connectedCallback() {
      this.recipientForm = this.closest('xo-product-recipient-form');
      this.checkbox = this.recipientForm?.querySelector(
        'input[type="checkbox"][name="properties[__shopify_send_gift_card_to_recipient]"]'
      );
      this.buttons = Array.from(this.querySelectorAll('[data-recipient-mode]'));

      if (!this.recipientForm || !this.checkbox || this.buttons.length === 0) return;

      this.handleClick = this.handleClick.bind(this);
      this.handleChange = this.handleChange.bind(this);

      this.addEventListener('click', this.handleClick);
      this.recipientForm.addEventListener('change', this.handleChange);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.recipientForm, {
        attributes: true,
        attributeFilter: ['xo-active'],
      });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.recipientForm?.removeEventListener('change', this.handleChange);
      this.observer?.disconnect();
    }

    handleClick(event) {
      const button = event.target.closest('[data-recipient-mode]');
      if (!button || !this.contains(button)) return;

      const sendToRecipient = button.dataset.recipientMode === 'recipient';
      if (this.checkbox.checked !== sendToRecipient) {
        this.checkbox.checked = sendToRecipient;
        this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.sync();
    }

    handleChange(event) {
      if (event.target === this.checkbox) this.sync();
    }

    sync() {
      const activeMode = this.checkbox.checked ? 'recipient' : 'self';

      this.buttons.forEach((button) => {
        const isActive = button.dataset.recipientMode === activeMode;
        button.setAttribute('aria-selected', String(isActive));
        button.tabIndex = isActive ? 0 : -1;
      });
    }
  }

  customElements.define('clei-gift-card-recipient-tabs', CleiGiftCardRecipientTabs);
}
